<script setup>
    import { router } from '@inertiajs/vue3';
    import AppLayout from '@/Layouts/AppLayout.vue';
    import DashboardSidebar from '@/Jetstream/DashboardSidebar.vue';
    import { nextTick, ref, onMounted, onUnmounted, reactive } from "vue";
    import ConfettiExplosion from "vue-confetti-explosion";

    // includes we need to front end locale magic
    import { useI18n } from 'vue-i18n';
    // Get locale as set in cookie
    let { locale } = useI18n({ useScope: 'global' });

    const props = defineProps({
        submittedToolkit: Object,
        toolkitDetails: Object,
        loggedInUserId: Number,

        filters: {
            type: Object,
            default: () => ({}),
        },
    });

    const programme = router.page.props.ziggy.programme;
    const organisation = router.page.props.ziggy.organisation;
    const urlNamePrefix = organisation ? "gi." : "";

    const organisation_name = (programme.organisation_custom_name && programme.organisation_custom_name.length == 0) ? programme.organisation_custom_name : 'Organisation' ;
    //const team_name = (programme.organisation_custom_name && programme.team_custom_name.length == 0) ? programme.team_custom_name : 'Team' ;

    let team_custom_name = programme.team_custom_name;
    if (team_custom_name) {
        if(team_custom_name.constructor.name != 'Object') {
            team_custom_name = JSON.parse(team_custom_name);
        }
    }

    let default_team_name;

    if (locale.value == 'cy') {
        default_team_name = 'tîm';

    } else  {
        default_team_name = 'team';
    }

    let team_name = default_team_name;

    if (team_custom_name) {
        team_name =  team_custom_name[locale.value] == null ? default_team_name : team_custom_name[locale.value];
    }

    const default_text = router.page.props.ziggy.default_text;

    const convertToObject = (json) => {
        if (json.constructor.name != 'Object') {
            json = JSON.parse(json)
        }
        return json;
    }

    let submitted_text = null;

    if(default_text) {
        submitted_text = default_text.filter((item) => {
            return item.key == "toolkit_submission";
        });
        submitted_text = submitted_text[0];
        if (submitted_text) {
            submitted_text = convertToObject(submitted_text);
        }
    }

    const window = { width: 0, height: 0};
    const visible = reactive({visible: false});

    function handleResize() {
        window.width = document.body.clientWidth;
        window.height = document.body.clientHeight;
    }

    onMounted(() => {
        document.addEventListener('resize', handleResize);
        handleResize();
        visible.visible = true;
    })

    onUnmounted(() => document.removeEventListener('resize', handleResize))


</script>


<template>
    <AppLayout title="Submitted">
        <div class="container mx-auto flex flex-col lg:flex-row justify-between w-full">

            <div id="sos-programme-dashboard-sidebar" class="order-2 lg:order-1 w-full lg:w-1/4 xl:w-1/5 min-h-screen p-10 pt-5">
                <DashboardSidebar />
            </div>

            <div class="order-1 lg:order-2 w-full lg:w-3/4 xl:w-4/5 sos-programme-dashboard-content">
                <ConfettiExplosion v-if="visible.visible" :stageHeight="window.height -20" :stageWidth="window.width" />
                <div class="overflow-hidden pl-10 mb-10 pr-10 lg:pr-0 pt-3">
                    <div id="toolkit-header" class="md:flex">
                        <div class="md:basis-1/2">
                            <h1 class="dashboard-title pt-5">{{ $t('toolkit.submission.submitted') }}</h1>
                        </div>
                    </div>

                    <!-- if there is custom toolkit submission text -->
                    <div v-if="props.toolkitDetails.submission_text && props.toolkitDetails.submission_text[$i18n.locale]" class="pt-5 lg:pr-0 text-center">
                        <h3>{{ $t('toolkit.submission.congratulations', { team: $page.props.auth.user.current_team.name }) }}</h3>
                        <div v-html="props.toolkitDetails.submission_text[$i18n.locale]"></div>
                    </div>

                    <!-- if there is default submission text -->
                    <div v-else-if="(submitted_text && submitted_text.content && submitted_text.content[$i18n.locale])" class="pt-5 lg:pr-0 text-center">
                        <h3>{{ $t('toolkit.submission.congratulations', { team: $page.props.auth.user.current_team.name }) }}</h3>
                        <div v-html="submitted_text.content[$i18n.locale]"></div>
                    </div>

                    <!-- if not, use the fallback submission text -->
                    <div v-else class="pt-5 lg:pr-0 text-center">
                        <h3>{{ $t('toolkit.submission.congratulations', { team: $page.props.auth.user.current_team.name }) }}</h3>
                        <p>{{ $t('toolkit.submission.details_1') }} {{ props.toolkitDetails.name }} {{$t('toolkit.submission.details_2')}} {{ programme.name }} <span v-if="organisation">{{$t('toolkit.submission.details_3')}} {{ organisation.name }}</span>.</p>

                        <p>{{$t('toolkit.submission.details_4')}}</p>
                    </div>

                </div>
            </div>
        </div>
    </AppLayout>
</template>
